'use strict';
import React from 'react';
import { Provider } from 'react-redux';
import {configureStore} from 'contact/state';
import ContactTent from 'contact/contactTent';

export default class Contact extends React.Component {
    componentWillMount() {
        this.store = configureStore(this.props);
    }
    render() {
        return (
            <Provider store={this.store}>
                <ContactTent {...this.props} />
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/contact/index.jsx